import { EVENTS } from '../constants/multiple-select-button-constants.js'

/**
 * Event handling for Multiple Select Button component
 * Giữ nguyên logic từ file gốc để maintain compatibility
 */
export function useMultipleSelectButtonEvents(props, emit, componentState) {
  
  // Main click item handler - giữ NGUYÊN logic từ file gốc
  const clickItem = (item) => {
    const { cacheSelected, effectiveValueField } = componentState
    
    // Toggle selection logic từ file gốc
    if (cacheSelected.value.has(item[effectiveValueField.value])) {
      cacheSelected.value.delete(item[effectiveValueField.value])
    } else {
      cacheSelected.value.set(item[effectiveValueField.value], item)
    }
    
    // Emit events - giữ nguyên từ file gốc
    emit(EVENTS.MENU_CLICK, item)
    emit(EVENTS.UPDATE_SELECTED, Array.from(cacheSelected.value.values()))
  }
  
  // Helper method để check if item is selected (for template usage)
  const isItemChecked = (item) => {
    const { cacheSelected, effectiveValueField } = componentState
    return cacheSelected.value.has(item[effectiveValueField.value])
  }
  
  return {
    // Main event handlers
    clickItem,
    
    // Helper methods
    isItemChecked
  }
}
